export const CONCIERGE_SETTINGS_LOAD_SUCCESS = "CONCIERGE_SETTINGS_LOAD_SUCCESS";
export const CONCIERGE_SETTINGS_LOAD_FAIL = "CONCIERGE_SETTINGS_LOAD_FAIL";